import React from 'react';
import PropTypes from 'prop-types';
import TableInformation from '../SF/table/TableInformation';
import StickyFooterLayout from '../common/StickyFooterLayout';
import InterventionListTable from './InterventionListTable';

function InterventionList(props) {

  const getStickyFooter = () =>
      <TableInformation itemName={props.itemName}
                        itemsPerPage={props.interventionsPerPage}
                        start={props.start}
                        totalItems={props.totalInterventions}
                        totalSelected={props.selectedInterventions.length} />;

  return <StickyFooterLayout content={(<InterventionListTable {...props} />)}
                             footer={getStickyFooter()} />
  
}

export default InterventionList;

InterventionList.defaultProps = {
  itemName: 'Items'
};

InterventionList.propTypes = {
  itemName: PropTypes.string.isRequired,
  interventionsPerPage: PropTypes.number.isRequired,
  selectedInterventions: PropTypes.arrayOf(PropTypes.number).isRequired,
  start: PropTypes.number.isRequired,
  totalInterventions: PropTypes.number.isRequired
};
